import { z } from "zod";
import { stepGetBaseSchema } from "./stepGetBaseSchema";
import { common } from "../common";

export const sendToDestinationStepGetSchema = z.object({
  ...stepGetBaseSchema.shape,
  type: z.literal("SEND_TO_DESTINATION"),
  step_data: z.object({
    destination_canvas_id: common.objectId,
  }),
});
